const PRODUCTION_API_STYLES = process.env.REACT_APP_PRODUCTION_API_STYLES;
const PRODUCTION_API_TOKEN_STYLES =
  process.env.REACT_APP_PRODUCTION_API_TOKEN_STYLES;

export const fetchStyles = async () => {
  try {
    if (
      !process.env.REACT_APP_PRODUCTION_API_STYLES ||
      !process.env.REACT_APP_PRODUCTION_API_TOKEN_STYLES
    ) {
      throw new Error(
        "API endpoint or token is missing in the environment variables.",
      );
    }
    const headers = new Headers({
      Authorization: `token ${PRODUCTION_API_TOKEN_STYLES}`,
      "Content-Type": "application/json",
    });

    const response = await fetch(`${PRODUCTION_API_STYLES}/api/styles`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorDetails = await response.text();
      throw new Error(
        `Request failed with status ${response.status}. Details: ${errorDetails}`,
      );
    }

    const data = await response.json(); // Parse JSON response
    return data;
  } catch (error) {
    console.error("Error fetching ai-avatar/styles:", error.message);
    throw error; // Re-throw for caller to handle if needed
  }
};

export const deleteStyles = async (id) => {
  try {
    // Validate required environment variables

    if (!PRODUCTION_API_STYLES) {
      throw new Error("API is missing in the environment variables.");
    }

    // Set up headers
    const headers = new Headers({
      Authorization: `token ${PRODUCTION_API_TOKEN_STYLES}`,
    });

    // API URL with query parameters
    const url = `${PRODUCTION_API_STYLES}/api/delete_style/?id=${id}`;

    // Make DELETE request
    const response = await fetch(url, {
      method: "DELETE",
      headers,
    });

    if (!response.ok) {
      throw new Error(`Failed to delete style. Status: ${response.status}`);
    }

    const result = await response.text();
    return result;
  } catch (err) {
    console.error("Error deleting ai-avatar/styles:", err.message);
    throw err;
  }
};

export const createStyle = async (data) => {
  try {
    // Validate the input object
    if (!data || !data.thumbnailImg) {
      throw new Error("Invalid input: Thumbnail image is required.");
    }
    const headers = new Headers({
      Authorization: `token ${PRODUCTION_API_TOKEN_STYLES}`,
    });

    const formdata = new FormData();
    formdata.append("name", data.name || "default_name");
    formdata.append("prompt", data.prompt || "default_prompt");
    formdata.append("thumbnail", data.thumbnailImg, data.thumbnailImg.name);
    formdata.append("is_premium", data.is_premium ? "true" : "false");

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: formdata,
      redirect: "follow",
    };

    const response = await fetch(
      `${PRODUCTION_API_STYLES}/api/add_style/`,
      requestOptions,
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.text();
    return result; // Return result for further use if needed
  } catch (error) {
    console.error("Error creating style:", error.message);
    throw error; // Re-throw for the caller to handle
  }
};

export const updateStyle = async (payload) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `token ${PRODUCTION_API_TOKEN_STYLES}`);

    const formdata = new FormData();

    for (const key in payload) {
      if (
        payload[key] instanceof File &&
        payload[key].type.startsWith("image/")
      ) {
        formdata.append(key, payload[key], payload[key].name);
      } else {
        formdata.append(key, payload[key]);
      }
    }

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    if (!PRODUCTION_API_STYLES) {
      throw new Error("API base URL is not defined.");
    }

    const response = await fetch(
      `${PRODUCTION_API_STYLES}/api/update_style/`,
      requestOptions,
    );

    if (!response.ok) {
      const errorDetails = await response.text();
      throw new Error(
        `Error: ${response.status} - ${response.statusText}. Details: ${errorDetails}`,
      );
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error updating style:", error.message);
    throw error;
  }
};
